import { useLocation } from "@reach/router";
import React, { useState } from "react";
import ModalCPE from '../../components/modals/cpeModal';
import { useEventContext } from "../../context/EventProvider";
import useEventDetails from "../../hooks/useEventDetails";
import { StyledPrimaryHeader as H2 } from "../styled";
import { ArticleBar } from "./aboutStyles";

const Articles = props => {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
    <ModalCPE isOpen={modalOpen} onClose={closeModal}>
                  <b className="cpebold">2025 Federal Forum</b> attendees
                  are eligible to receive continuing professional education
                  (CPE) credits. Attendees can earn a maximum of 4 CPE credits
                  in information technology.
                  <br />
                  <br />
                  In order to verify your CPEs, please document your name on the
                  CPE attendance sheet located at the registration desk onsite.
                  Be sure to return to the registration desk to document your
                  time out. If sign in and/or sign out times are not documented,
                  FedScoop is unable to verify your attendance and therefore
                  cannot award CPE credit.
                  <br />
                  <br />
                  <b className="cpebold">Additional details:</b>
                  <br />
                  <b className="cpebold">Delivery Method:</b> Group-Live
                  <br />
                  <b className="cpebold">Program Level:</b> Intermediate
                  <br />
                  <b className="cpebold">Prerequisites:</b> Previous
                  professional experience in IT and technology is recommended
                  for all participants
                  <br />
                  <b className="cpebold">Advance Preparation:</b> No advance
                  preparation necessary
                  <br />
                  <b className="cpebold">Contact:</b>{' '}
                  <a
                    href="mailto:kylie.galyen@scoopnewsgroup.com"
                    target="_blank"
                    className="cpe-email"
                  >
                    Kylie Galyen
                  </a>{' '}
                  for details on obtaining CPE credits at the event.
                  <br />
                  <br />
                  <img
                    src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/trellix/2023/cybersecurity-summit/CPElogo.jpg"
                    className="cpe-image"
                    alt="CPE"
                  />
                  <p className="sngcpe">
                    Scoop News Group is registered with the National Association
                    of State Boards of Accountancy (NASBA) as a sponsor of
                    continuing professional education on the National Registry
                    of CPE Sponsors. State boards of accountancy have final
                    authority on the acceptance of individual courses for CPE
                    credit. Complaints regarding registered sponsors may be
                    submitted to the National Registry of CPE Sponsors through
                    its website:{' '}
                    <a
                      href="https://www.nasbaregistry.org"
                      target="_blank"
                      className="cpe-nasbar"
                    >
                      www.NASBARegistry.org
                    </a>
                    .
                  </p>
    </ModalCPE>
    <ArticleBar id="about">
      <div className="wrapUp">
        <p>
        There is an urgent need to transform the federal workforce into a more agile and efficient model. Modernization is not just about technology, but about people. HR must play a central role in achieving mission objectives by building a strong and adaptable workforce, prioritizing skills and abilities (over traditional credentials), and embracing AI solutions to revolutionize how it attracts, retains, and manages talent, ultimately creating a more dynamic and responsive workforce.
        </p>
      </div>
      <p className="cpe-credit">
                Interested in earning continuing professional education (CPE)
                credits?
                <br />
                <a onClick={openModal} className="cpe-link">
                  Click here to learn more! &#12299;
                </a>
                
              </p>
              <br />
              <br />
              <br />
              <br />
    </ArticleBar>
    </>
  );
};

export default Articles;
